/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var Async = require('.')
var First = require('../core/types').proxy('First')

var curry = require('../core/curry')
var isFunction = require('../core/isFunction')
var isSameType = require('../core/isSameType')

var constant = function (x) { return function () { return x; }; }

var applyTransform = function (left, first) { return first.valueOf().either(
    constant(Async.Rejected(left)),
    Async.Resolved
  ); }

// firstToAsync : e -> First a -> Async e a
// firstToAsync : e -> (a -> First b) -> a -> Async e b
function firstToAsync(left, first) {
  if(isFunction(first)) {
    return function(x) {
      var m = first(x)

      if(!isSameType(First, m)) {
        throw new TypeError('firstToAsync: First returning function required for second argument')
      }

      return applyTransform(left, m)
    }
  }

  if(isSameType(First, first)) {
    return applyTransform(left, first)
  }

  throw new TypeError('firstToAsync: First or First returning function required for second argument')
}

module.exports = curry(firstToAsync)
